
import { ymGoalCheck } from '~/helpers/ym_helper';

export default {
  name: 'ProductCardTemplate',

  props: {
    isAddToCart: {
      type: Boolean,
      default: false,
    },

    countAddedToCart: {
      type: Number,
      default: null,
    },

  },

  emits: ['addProductToCard', 'changeProductCount'],

  methods: {
    addProductToCard: async function () {
      await this.$emit('addProductToCard');

      ymGoalCheck({
        ymGoal: 'add_to_cart',
        ymNumber: process.env.yandexMetriks,
      });

      this.$popUpNotification({
        title: 'Подтверждение',
        message: 'Ваш товар успешно добавлен в корзину',

        buttonSuccessLabel: 'Оформить заказ',
        buttonSuccessEvent: this.popUpClickSuccess.bind(this),

        buttonErrorLabel: 'Продолжить покупки',
        buttonErrorEvent: this.popUpClickError.bind(this),
      });
    },

    changeProductCount(count) {
      this.$emit('changeProductCount', count);
    },

    popUpClickSuccess: function () {
      this.$store.commit('pop-up-notification/closePopUp');
      this.$router.push('/cart');
    },
    popUpClickError: function () {
      this.$store.commit('pop-up-notification/closePopUp');
    },
  },
};
